<template>
  <div>
    <div class="wheel-wrapper">
      <div
        class="wheel-pointer"
        @click="onClickRotate"
      >
        <img src="@/assets/image/arrow.png" alt="">
      </div>
      <div
        class="wheel-bg"
        :class="{freeze: freeze}"
        :style="`transform: rotate(${wheelDeg}deg);`"
      >
        <div class="prize-list">
          <div
            class="prize-item-wrapper"
            :class="'mm' + index"
            v-for="(item,index) in prizeList"
            :key="index"
            :style="`transform: rotate(-${wheelDeg}deg)`"
          >
<!--            :style="`transform: rotate(${(-45) * index}deg)`"-->
            <div
              class="prize-item"
            >
              <div class="prize-name">
<!--                {{ item.name }}-->
                <img src="@/assets/image/i_market.png" alt="">
                <img :src="item.icon" class="pImg">
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script src="//unpkg.com/vue/dist/vue.js"></script>
<script>
  export default {
    data () {
      return {
        freeze: false,
        rolling: false,
        wheelDeg: 0,
        prizeNumber: 8,
        prizeListOrigin: [
          {
            icon: "https://picsum.photos/40?random=1",
            name: "$1"
          },
          {
            icon: "https://picsum.photos/40?random=6",
            name: "2"
          },
          {
            icon: "https://picsum.photos/40?random=2",
            name: "3"
          },
          {
            icon: "https://picsum.photos/40?random=3",
            name: "4"
          },
          {
            icon: "https://picsum.photos/40?random=6",
            name: "5"
          },
          {
            icon: "https://picsum.photos/40?random=4",
            name: "6"
          }
        ]
      }
    },
    computed: {
      prizeList () {
        return this.prizeListOrigin.slice(0, this.prizeNumber)
      }
    },
    methods:{
      onClickRotate() {
        if (this.rolling) {
          return;
        }
        this.rolling = true;
        const { wheelDeg, prizeList } = this;
        // const random = Math.floor(Math.random() * (prizeList.length ));
        const random = 2;
        console.log(random);
        this.wheelDeg =
          wheelDeg -
          wheelDeg % 360 +
          2 * 360 +
          (360 - 360 / prizeList.length * random);
        setTimeout(() => {
          this.rolling = false;
          alert("Result：" + prizeList[random].name);
        }, 4500);
      }
    },
    watch: {
      prizeNumber () {
        this.freeze = true
        this.wheelDeg = 0

        setTimeout(() => {
          this.freeze = false
        }, 0)
      }
    }
  }
</script>
<style lang="less" scoped>
  html {
    /*background: #DD7C7D;*/
  }

  .wheel-wrapper {
    width: 600px;
    height: 600px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .wheel-pointer {
    width: 120px;
    height: 120px;
    border-radius: 1000px;
    /*background: yellow;*/
    position: absolute;
    left: 50%;
    top: 45%;
    transform: translate(-50%, -50%);
    text-align: center;
    line-height: 60px;
    z-index: 10;
    img{
      width: 120px;
      /*height: 120px;*/
    }
  }
  .wheel-bg {
    width: 100%;
    height: 100%;
    border-radius: 1000px;
    /*overflow: hidden;*/
    /*transition: transform 3s ease-in-out;*/
    transition: transform 6s;
    /*background: #7EEF97;*/
    background: url('../assets/image/w-border.png')no-repeat;
    background-size: 100% 100%;
    position: relative;

    &.freeze {
      transition: none;
      background: red;
    }
  }

  .prize-list {
    width: 100%;
    height: 100%;
    position: relative;
    text-align: center;
  }

  .prize-item-wrapper {
    position: absolute;
    top: 0;
    left: 35%;
    transform: translateX(-50%);
    width: 180px;
    height: 180px;
    z-index: 10;
    transform-origin: 49% 14%;
    /*transform-origin: top center;*/
    transition: all 6s;
  }
  .mm1{
    left: 460px;
    top: 130px;
  }
  .mm2{
    left: 460px;
    top: 410px;
  }
  .mm3{
    top: 560px;
  }
  .mm4{
    left: -50px;
    top: 410px;
  }
  .mm5{
    left: -50px;
    top: 130px;
  }
  .prize-item {
    width: 100%;
    height: 100%;
    transform-origin: bottom;

    .prize-name {
      font-size: 0;
      height: 180px;
      position: relative;
      img{
        width: 180px;
        height: 180px;
      }
      .pImg{
        position: absolute;
        width: 70px;
        height: 70px;
        top: 50%;
        left: 50%;
        transform: translateX(-50%) translateY(-50%);
      }
    }

    .prize-icon {}
  }
</style>

